import { CSSProperties, ReactNode, useState } from "react";
import * as React from "react";

import "../styles/panel.css";

export { CollapsiblePanel, Props as CollapsiblePanelProps };

type Props = {
  title: string;
  open?: boolean;
  children: ReactNode;
  headerChildren?: ReactNode;
  className?: string;
  style?: CSSProperties;
  sticky?: boolean;
  scrollable?: boolean;

  panelHeader?: React.ReactNode;
  headerStyle?: CSSProperties;

  /* TODO: refactor out, this sucks */
  disableClick?: boolean;
};

const CollapsiblePanel = (props: Props) => {
  const [open, setOpen] = useState<boolean>(props.open ?? false);

  return (
    <div
      className={`panel ${props.sticky ? "sticky" : ""} ${open ? "" : "closed"} ${props.className || ""}`}
      style={props.style}
      data-title={props.title}
    >
      {/* panel header */}
      <div
        className={`header noselect`}
        style={props.headerStyle}
        onClick={(e) => {
          if (props.disableClick) {
            return e.stopPropagation();
          }
          setOpen(!open);
        }}
      >
        {props.panelHeader && props.panelHeader}
        {!props.panelHeader && (
          <>
            <span> {props.title} </span>
            <span
              onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              {props.headerChildren}
            </span>
          </>
        )}
      </div>
      {/* panel body, if visibile */}
      <div className={`body ${props.scrollable ? "scrollable" : ""}`}>
        {props.children}
      </div>
      <div className={"foot"}></div>
    </div>
  );
};
